import { mainWhite } from "shared/colors";

export const customDividerStyle = {
  dividerStyle: {
    height: "40px",
    borderColor: mainWhite,
    margin: "8px 10px 0 10px",
  },
};
